// Question Feedback Types
export const FEEDBACK_FETCH_REQUEST = 'FEEDBACK_FETCH_REQUEST';
export const FEEDBACK_FETCH_SUCCESS = 'FEEDBACK_FETCH_SUCCESS';
export const FEEDBACK_FETCH_FAILURE = 'FEEDBACK_FETCH_FAILURE';

export const FEEDBACK_CREATE_REQUEST = 'FEEDBACK_CREATE_REQUEST';
export const FEEDBACK_CREATE_SUCCESS = 'FEEDBACK_CREATE_SUCCESS';
export const FEEDBACK_CREATE_FAILURE = 'FEEDBACK_CREATE_FAILURE';

export const FEEDBACK_UPDATE_REQUEST = 'FEEDBACK_UPDATE_REQUEST';
export const FEEDBACK_UPDATE_SUCCESS = 'FEEDBACK_UPDATE_SUCCESS';
export const FEEDBACK_UPDATE_FAILURE = 'FEEDBACK_UPDATE_FAILURE';

export const FEEDBACK_DELETE_REQUEST = 'FEEDBACK_DELETE_REQUEST';
export const FEEDBACK_DELETE_SUCCESS = 'FEEDBACK_DELETE_SUCCESS';
export const FEEDBACK_DELETE_FAILURE = 'FEEDBACK_DELETE_FAILURE';

export const FEEDBACK_RESET = 'FEEDBACK_RESET';

// My Feedback (student view)
export const MY_FEEDBACK_FETCH_REQUEST = 'MY_FEEDBACK_FETCH_REQUEST';
export const MY_FEEDBACK_FETCH_SUCCESS = 'MY_FEEDBACK_FETCH_SUCCESS';
export const MY_FEEDBACK_FETCH_FAILURE = 'MY_FEEDBACK_FETCH_FAILURE';
